import styled from "@emotion/styled"

const ListTenItemContent = styled.div``

export default ListTenItemContent
